/* eslint-disable no-console */

import type { MockedFeaturesMap } from '@splitsoftware/splitio/types/splitio';

import { localhostFeaturesKey } from 'src/shared/constants/FeatureFlag';

const loadMockedFeatures = () => {
  const features = JSON.parse(
    localStorage.getItem(localhostFeaturesKey) ?? '{}',
  ) as MockedFeaturesMap;

  const hasFeatures = Object.entries(features).length > 0;

  if (__DEV__) {
    console.info(
      `%c🤡 · Use localStorage.setItem('local-split-features', JSON.stringify({'feature_flag_here': 'on'})); to mock features locally`,
      'color:dodgerblue',
    );
  }

  console.info(
    `🤡 · SplitProvider: using locally mocked features${
      hasFeatures ? '' : ' (ℹ️ — no features currently mocked)'
    }`,
  );

  if (hasFeatures) {
    console.table(features);
  }

  return features;
};

export { loadMockedFeatures };
